import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { isStaleBuild } from "@/lib/versionWatcher";

/** When a newer version is published, turn the next in-app navigation into a full load. */
export const StaleBuildNavigator = () => {
  const location = useLocation();
  const first = useRef(true);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    if (isStaleBuild()) {
      window.location.assign(location.pathname + location.search + location.hash);
    }
  }, [location.pathname, location.search, location.hash]);

  return null;
};
